// @ts-check

/**
 * @typedef {import('../types').RootLayoutProps} RootLayoutProps
 * @typedef {import('../types').PageTemplatesMap} PageTemplatesMap
 */

import React from 'react'
import Header from './header'
import Footer from './footer'
import pageTemplates from '../data/page-templates.json'

/** @param {RootLayoutProps} props */
const RootLayout = ({ element, props }) => {
  const location = typeof window !== 'undefined' ? window.location : props?.location || {pathname: "/"}
  /** @type {PageTemplatesMap} */
  const pageMap = pageTemplates.pages
  // @ts-ignore
  const meta = pageMap[location?.pathname]
  const title = meta?.title || 'ProSource Home Inspection'

  return (
    <div>
      <Header location={location} title={title} />
      <main>
        {element}
      </main>
      <Footer />
    </div>
  )
}

export default RootLayout
